var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Campaigns & Events")])])]), _vm._v(" "), _c('Cleaniness'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "cc"
    }
  }), _vm._v(" "), _c('IndraDhanush'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "mas"
    }
  }), _vm._v(" "), _c('Mas'), _vm._v(" "), _c('a', {
    attrs: {
      "id": "wad"
    }
  }), _vm._v(" "), _c('Wad'), _vm._v(" "), _c('Kishore'), _vm._v(" "), _c('Asha'), _vm._v(" "), _c('SpecialCamps')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15252ea9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Events.vue
// module id = GB7n
// module chunks = 0